// AddNewServiceForm.js
import React, { useEffect, useState } from "react";
import "./AddNewServiceModal.css"; // Import the CSS for the form
import { get, post } from "../../../utility/fetch";

const AddFundsToWallet = ({ onClose, wallets, toFund }) => {
  const [amount, setAmount] = useState("");
  const [additionalNote, setAdditionalNote] = useState("");
  const userInfo = JSON.parse(localStorage.getItem("USER_INFO"));

  useEffect(() => {
    // fetchMedications()
  }, []);

  const handleSubmit = async (e) => {
    
    console.log({
      amount: parseFloat(amount), // Convert amount to a number
      additionalNote,
      transactionType: toFund ? "credit" : "debit",
    });

    let payload = {
      walletId: wallets,
      amount: parseFloat(amount),
      transactionType: toFund ? "credit" : "debit",
      description: additionalNote,
      status: "",
    };

    try {
      const response = toFund?await post("/wallet/credit", payload):await post("/wallet/debit", payload)

      console.log(response);
    } catch (error) {
      console.error("Error fetching laboratories:", error);
    }

    // Clear form fields
    setAmount("");
    setAdditionalNote("");

    onClose(); // Close the modal after submission
  };

  return (
    <div className="add-service-form-container">
      <div className="form-header">
        <h2>Fund Wallet</h2>
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
      </div>
      <div className="form-body">
        <div className="service-modal-form-group">
          <input
            type="number" // Use type="number" for amount
            id="amount"
            className="form-input"
            placeholder="Enter amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            step="0.01" // Allows decimal amounts
            required
          />
        </div>

        <div className="service-modal-form-group">
          <textarea
            id="additionalNote"
            className="form-textarea"
            placeholder="Additional Note"
            value={additionalNote}
            onChange={(e) => setAdditionalNote(e.target.value)}
            rows="4" // Set initial rows
          ></textarea>
        </div>

        <button onClick={handleSubmit} className="submit-button">
          Submit
        </button>
      </div>
    </div>
  );
};

export default AddFundsToWallet;
